module.exports = __webpack_public_path__ + "static/media/001-Ueberzeugen_ID_8.554477af.mp3";